import { render, staticRenderFns } from "./CategoryCombo.vue?vue&type=template&id=52f58136&"
import script from "./CategoryCombo.vue?vue&type=script&lang=js&"
export * from "./CategoryCombo.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCombo.vue?vue&type=style&index=0&id=52f58136&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports